export type VaultPreview = {
  id: string;
  alt: string;
  src: string;
};

export const vaultPreviews: VaultPreview[] = [
  {
    id: 'meal-planning',
    alt: 'Volume 3 — The Modular Meal Planning System opening page',
    src: 'https://cdn.magicpatterns.com/uploads/a1KLFStrZBTwRsUWwMcR5s/Screenshot_20260912_122655_Drive.jpg',
  },
  {
    id: 'attraction-funnel',
    alt: 'Volume 6 — The Premium Patient Attraction System funnel diagram',
    src: 'https://cdn.magicpatterns.com/uploads/w2E1VUB6z6mWMm7DbqMEwi/Screenshot_20260912_122752_Drive.jpg',
  },
  {
    id: 'transtheoretical',
    alt: 'Volume 4 — The Transtheoretical Model in practice diagram',
    src: 'https://cdn.magicpatterns.com/uploads/v6bA6ns1WknfF9Bpa6SDBS/Screenshot_20260912_122728_Drive.jpg',
  },
  {
    id: 'meal-builder',
    alt: 'Modular Meal Builder clinical template',
    src: 'https://cdn.magicpatterns.com/uploads/4dfzJiPLd4Y1yshrrFugeT/Screenshot_20260912_122844_Drive.jpg',
  },
  {
    id: 'anti-inflammatory',
    alt: 'Anti-Inflammatory Kitchen Essentials infographic',
    src: 'https://cdn.magicpatterns.com/uploads/giw9qthE27rTUUeqTm2qhV/Screenshot_20260912_123026_Drive.jpg',
  },
  {
    id: 'hydration-tracker',
    alt: 'Hydration and Micro-Habit weekly tracker template',
    src: 'https://cdn.magicpatterns.com/uploads/twyhkGQ7rP9Uocji5kNDza/Screenshot_20260912_122906_Drive.jpg',
  },
];
